import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => (
  <div className="ss-sheet">
    <p className="ss-kicker">404</p>
    <h1 className="ss-title">This page isn’t on the board</h1>
    <p className="ss-sub">That link may be old. Head home to create or join a room.</p>
    <Link to="/" className="ss-btn ss-btn-primary">
      Back home
    </Link>
  </div>
);

export default NotFound;
